import React, { useMemo } from 'react';
var ModalHeader = function (_a) {
    var className = _a.className, children = _a.children, isModalAdmin = _a.isModalAdmin;
    var renderContent = useMemo(function () {
        var classNameResult = 'gr-modal-header ' +
            (isModalAdmin ? 'gr-modal-header-admin ' : '') +
            (className ? className : '');
        return React.createElement("div", { className: classNameResult }, children);
    }, [children, className]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { ModalHeader };
//# sourceMappingURL=ModalHeader.js.map